module.exports = __webpack_public_path__ + "static/media/award-2.61ee9eb0.png";